module.exports = __webpack_public_path__ + "static/media/freightspeed.9e0d9ba7.png";